import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  SelectChangeEvent,
  useTheme,
} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import SearchIcon from '@mui/icons-material/Search';
import {SEARCH_OBJECT} from '@app/screens/module-specific-utilities/module-specific-utilities.types';
import {MenuProp, useStyles} from '@app/screens/Styles/style';
import {approveExpenseStateSelector} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/selectors';
import {useDispatch, useSelector} from 'react-redux';
import {expenseReportsStateSelector} from '@app/screens/module-specific-utilities/pages/expense-reports/redux/selectors';
import {expenseReportsActions} from '@app/screens/module-specific-utilities/pages/expense-reports/redux';
import {CustomMenuItem} from '@app/screens/module-specific-utilities/components/approve-expenses/ApproveExpenseHeader';
import React, {useEffect, useState} from 'react';
import {
  approveExpenseStateActions,
  fetchDivisionDataCreator,
  fetchStaffDataCreator,
} from '@app/screens/module-specific-utilities/pages/approve-expenses/redux/slice';
import {fetchExpenseStatusReportCreator} from '@app/screens/module-specific-utilities/pages/expense-reports/redux/slice';
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import {tableRowKeys} from '@app/screens/module-specific-utilities/components/expense-reports/expense-status-report/ExpenseStatusReport';
import {getHeaderStyles} from '@app/screens/module-specific-utilities/components/approve-expenses/ApproveExpenseTable';
import {isEqual} from 'lodash';
import {withPreventDoubleClick} from '@app/components/hoc';
import {style} from '@app/screens/module-specific-utilities/components/expense-reports/yearly-disbursement-summary/yearlySummaryHeader';
import {strings} from '@app/common/strings';
import {CSSProperties} from 'react';
import styles from '../../approve-expenses/ApproveExpenseHeader.module.css';

export enum ExpenseStatusCategory {
  PENDINGSUBMISSION = 'Pending Submission',
  PENDINGMANAGER = 'Pending Manager',
  PENDINGADMIN = 'Pending Admin',
  APPROVEDADMIN = 'Approved by Admin',
  NOTGENERATED = 'Not Generated',
}

const staffList: CSSProperties = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  maxWidth: 200,
};

const selectAllContainer: CSSProperties = {
  padding: '6px 16px',
};

const checkmark: CSSProperties = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  height: '20px',
  width: '20px',
  zIndex: 10,
  border: '1px solid rgb(118, 118, 118)' /* Border color of the checkbox */,
  borderRadius: '3px' /* Optional: Add rounded corners */,
};

const divisionContainer: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-around',
  width: '100%',
};

const buttonContainer: CSSProperties = {
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  height: 80,
  marginBottom: -10,
  marginTop: 50,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const selectedStaffAndEmployeeCode = (
  selectedStaff: any,
  value: any,
  key: string,
) => {
  const filteredSelectedStaff = selectedStaff.filter((staff: any) =>
    value.includes(staff.divisionId),
  );
  const selectedEmployeeCode = filteredSelectedStaff.map(
    (staff: any) => staff[key],
  );

  return {filteredSelectedStaff, selectedEmployeeCode};
};

export const renderComponent = (
  selected: any,
  selectedStaff: any,
  string: any,
) => {
  return (
    <div style={staffList}>
      {' '}
      {selectedStaff.map(
        (value: any) =>
          selected?.some((id: any) =>
            string === 'TA'
              ? id == value?.employeeCode
              : id === value.staffPositionId,
          ) &&
          `${value?.fullName}-${value?.employeeCode}${
            selected.indexOf(value?.employeeCode) === selected.length - 1
              ? ''
              : ', '
          }`,
      )}
    </div>
  );
};

export const toolTip = (selectedStaff: any[], selectedStaffData: any) => {
  return selectedStaff
    .filter((value: any) =>
      selectedStaffData?.filter((id: any) => id === value?.employeeCode),
    )
    .map((value: any) => `${value?.fullName}-${value?.employeeCode}`)
    .join(', ');
};

export const SearchComponent: React.FC<{
  staffEditHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({staffEditHandler}) => {
  return (
    <TextField
      size="small"
      style={{width: '100%'}}
      autoFocus
      placeholder="Type to search..."
      InputProps={{
        style: {
          height: 30,
          fontSize: 11,
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      onChange={staffEditHandler}
      onKeyDown={e => {
        if (e.key !== 'Escape') {
          e.stopPropagation();
        }
      }}
    />
  );
};

export const SelectStaff: React.FC<{
  filteredData: any;
  selectedStaffData: any;
  selectedStaff: any;
  onStaffChange: (e: any) => void;
  type: string;
}> = ({
  children,
  filteredData,
  selectedStaffData,
  selectedStaff,
  onStaffChange,
  type,
}) => {
  return (
    <FormControl size="small" fullWidth>
      <InputLabel id="demo-simple-State">{`Staff`}</InputLabel>
      <Select
        inputProps={{
          'data-testid': 'dropdown-staff',
        }}
        labelId="staff"
        id="staff"
        disabled={!filteredData?.divisionId}
        label="Staff"
        size="small"
        multiple
        MenuProps={MenuProp}
        value={selectedStaffData || []}
        title={toolTip(selectedStaff, selectedStaffData)}
        onChange={onStaffChange}
        renderValue={(selected: any) =>
          renderComponent(selected, selectedStaff, type)
        }>
        {children}
      </Select>
    </FormControl>
  );
};

export const utilTA: any = {
  staffEditHandler: null,
  changeDivisionId: null,
  changeMonthYears: null,
  onStaffChange: null,
  handleClickGo: null,
};

export const getPreviousYearMonths = () => {
  const currentDate = new Date();
  const result = [];

  for (let i = 0; i < 12; i++) {
    const month = currentDate.getMonth() - i;
    const year =
      month < 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
    const adjustedMonth = (month + 12) % 12;
    const monthDesc = new Date(year, month, 1).toLocaleString('en-US', {
      month: 'short',
    });

    result.push({
      monthDesc,
      year,
      month: adjustedMonth + 1,
    });
  }

  return result;
};

const tableHeaderData = {
  userid: 'User ID',
  sapCode: 'SapCode',
  designationId: 'Designation Id',
  designationName: 'Designation',
  staffName: 'Staff Name',
  expenseMonth: 'Expense Month',
  expenseYear: 'Expense Year',
  divisionId: 'Division Id',
  divisionName: 'Division',
  hqId: 'hqId',
  hqName: 'HQ',
  status: 'Status',
};

const tableHeaderDataProp: string[] = Object.keys(tableHeaderData);
const tableHeaderDataVal: string[] = Object.values(tableHeaderData);

const resNestObj = (tableData: any) => {
  return tableData.map((tableObj: any) =>
    tableHeaderDataProp.map((key: any) => {
      if (
        key === 'id' &&
        (tableObj.section === 'Total' || tableObj.section === 'G. Total')
      ) {
        return null;
      } else if (key == 'month' && tableObj.month === null) {
        return tableObj.section;
      } else {
        return tableObj[key];
      }
    }),
  );
};

const ExpenseStatusReportHeader: React.FC<{setReport: any}> = ({setReport}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [validated, setValidated] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [selectedStaff, setSelectedStaff] = useState<any[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<any[]>([]);
  const [expenseStatus, setExpenseStatus] = React.useState<string[]>([]);

  const handleSelectAll = (e: {target: {checked: any}}) => {
    if (e.target.checked) {
      setExpenseStatus(names.map(e => e)); // Select all options
    } else {
      setExpenseStatus([]);
    }
  };

  const names = [
    ExpenseStatusCategory.PENDINGSUBMISSION,
    ExpenseStatusCategory.PENDINGMANAGER,
    ExpenseStatusCategory.PENDINGADMIN,
    ExpenseStatusCategory.APPROVEDADMIN,
    ExpenseStatusCategory.NOTGENERATED,
  ];

  const handleChange = (event: SelectChangeEvent<typeof expenseStatus>) => {
    const {
      target: {value},
    } = event;
    setExpenseStatus(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const theme = useTheme();

  const filterData = useSelector(
    expenseReportsStateSelector.getFiltersTASummary(),
  );

  const divisionData = useSelector(
    approveExpenseStateSelector?.getDivisionData(),
  );
  const selectedStaffData = useSelector(
    expenseReportsStateSelector?.getSelectedStaffData(),
  );

  const monthYearData = getPreviousYearMonths();

  const staffData: SEARCH_OBJECT[] = useSelector(
    approveExpenseStateSelector?.getStaffData(),
  );

  const statusReportData: any = useSelector(
    expenseReportsStateSelector.getStatusReportData(),
  );

  const isActive = useSelector(
    expenseReportsStateSelector.getIsActiveTaSummary(),
  );
  const isLoading: boolean = useSelector(
    approveExpenseStateSelector.getStaffLoading(),
  );

  const DebouncedButton = withPreventDoubleClick(Button, 400);

  const searchDebouncedStaff = (criteria: string | any[]) => {
    if (filterData?.divisionId && criteria?.length > 0) {
      dispatch(
        fetchStaffDataCreator({
          searchData: criteria,
          divisionIds: filterData?.divisionId,
          InActive: !isActive,
        }),
      );
    }
  };

  const staffEditHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e === undefined || e === null) return;
    if (e?.target?.value?.length >= 3) searchDebouncedStaff(e?.target?.value);
  };

   const changeDivisionId = (value: number[], type: string) => {
   
    value.forEach((element: number) => {
      if (
        element === 0 &&
        filterData?.divisionId?.length === divisionData.length
      ) {
        dispatch(
          expenseReportsActions?.setFiltersTA({
            [type]: [],
          }),
        );
      } else if (element === 0) {
        dispatch(
          expenseReportsActions?.setFiltersTA({
            [type]: divisionData.map((obj: any) => Object.values(obj)[1]),
          }),
        );
      } else {
        dispatch(
          expenseReportsActions?.setFiltersTA({
            [type]: value,
          }),
        );
      }
    });
  };
  // const changeDivisionId = (value: number[], type: string) => {
  //   const {filteredSelectedStaff, selectedEmployeeCode} =
  //     selectedStaffAndEmployeeCode(selectedStaff, value, 'employeeCode');
  //   if (value.length <= 10) {
  //     dispatch(
  //       expenseReportsActions.setFiltersTA({
  //         [type]: value,
  //       }),
  //     );
  //     dispatch(approveExpenseStateActions?.setStaffData([]));

  //     if (!isEqual(selectedStaff, filteredSelectedStaff)) {
  //       setSelectedStaff(filteredSelectedStaff);
  //       dispatch(
  //         expenseReportsActions?.setSelectedStaffData(selectedEmployeeCode),
  //       );
  //     }
  //   }
  //   dispatch(expenseReportsActions?.setStatusReportData([]));
  // };

  const changeMonthYears = function (values: any[], type: string) {
    values.forEach((element: number) => {
      if (
        element === 0 &&
        filterData?.monthYearData?.length === monthYearData.length
      ) {
        dispatch(
          expenseReportsActions?.setFiltersTA({
            [type]: [],
          }),
        );
      } else if (element === 0) {
        dispatch(
          expenseReportsActions?.setFiltersTA({
            [type]: monthYearData.map((obj: any) => Object.values(obj)[2]),
          }),
        );
      } else {
        dispatch(
          expenseReportsActions?.setFiltersTA({
            [type]: values,
          }),
        );
      }
    });
    if (values.length <= 0) {
      dispatch(
        expenseReportsActions.setFiltersTA({
          [type]: values,
        }),
      );
    }
  };

  const updateStaff = (event: any, prevSelectedStaff: any) => {
    return prevSelectedStaff.filter((staff: {employeeCode: any}) =>
      event.target.value.includes(staff.employeeCode),
    );
  };
  const condition = (updatedSelectedStaff: any, staff: any) =>
    !updatedSelectedStaff.some(
      (s: {employeeCode: number}) => s.employeeCode === staff.employeeCode,
    );
  const onStaffChange = (event: any) => {
    setSelectedStaff(prevSelectedStaff => {
      // Remove deselected staff codes
      const updatedSelectedStaff = updateStaff(event, prevSelectedStaff);
      // Add newly selected staff codes
      staffData.forEach(staff => {
        if (
          event.target.value.includes(staff.employeeCode) &&
          condition(updatedSelectedStaff, staff)
        ) {
          updatedSelectedStaff.push(staff);
        }
      });

      return updatedSelectedStaff;
    });
    dispatch(expenseReportsActions?.setSelectedStaffData(event.target.value));
  };

  const division = statusReportData?.header?.divName;
  const period = statusReportData?.header?.period?.replace(/,\s*$/, '');

  const addHeaderContent = (doc: any, division: any, period: any) => {
    const lineSpacing = 6;
    doc.text('MONTH WISE EXPENSE STATUS REPORT', 100, 12);
    doc.setFontSize(11);
    doc.text('Division: ' + division, 10, 20 + lineSpacing);
    const periodText = 'Period: ' + period;
    const periodLines = doc.splitTextToSize(periodText, 250);
    periodLines.forEach((line: any, index: number) => {
      doc.text(line, 10, 20 + (2 + index) * lineSpacing);
    });
  };

  const applyTableStyles = (doc: any, data: any, options: any) => {
    doc.autoTable({
      head: [tableHeaderDataVal],
      body: data,
      theme: 'grid',
      headStyles: getHeaderStyles(7),
      styles: {
        fontSize: 5,
        halign: 'center',
        textColor: [1, 1, 1, 1],
      },
      willDrawCell: (row: any, data: any, body: any) => {
        if (
          row.row.raw[4] === 'Total' ||
          row.row.raw[4] === 'G. Total' ||
          row.row.raw[4] === 'Month'
        ) {
          doc.setTextColor(0, 0, 0);
        }
      },
      ...options,
    });
  };

  const generatePDF = () => {
    const doc: any = new jsPDF('l', 'mm', 'a4');
    const data = resNestObj(statusReportData?.row);
    const options = {
      margin: {top: 48, left: 10},
      startY: 60,
    };

    addHeaderContent(doc, division, period);
    applyTableStyles(doc, data, options);

    const pageCount = doc.internal.getNumberOfPages();
    const date = new Date();
    const minutes = date.getMinutes();
    const dateStr = `${date.toLocaleDateString()} ${date.getHours()}:${
      minutes < 10 ? `0${minutes}` : minutes
    }`;

    doc.save('Expense_Status_Report.pdf');
  };

  const getRowValues = (tableRowKeys: any, rowData: any) => {
    return tableRowKeys.map((key: any) =>
      key === 'month' && rowData.month === null
        ? rowData.section
        : rowData[key],
    );
  };
  const fitToColumnExcelJs = (
    worksheet: any,
    data: any,
    tableRowKeys: string[],
    divisor?: number,
  ) => {
    let index = 1;
    for (const key of tableRowKeys) {
      const maxColumnWidth = Math.max(
        key ? key.toString().length * 10 : 0,
        ...data.map((obj: any) =>
          obj[key] ? obj[key].toString().length * 10 : 0,
        ),
      );
      if (key === 'travelItems') {
        worksheet.getColumn(index).width = 120;
        worksheet.getColumn(index).alignment = {wrapText: true};
      } else {
        worksheet.getColumn(index).width = maxColumnWidth / (divisor ?? 7);
      }
      index++;
    }
  };

  const downloadExcel = () => {
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet(
      strings.ModuleSpecificUtilitie.expenseReportPage.expenseReport,
    );
    let currentRowIdx = worksheet.rowCount;
    const divisionRow = worksheet.addRow([`Division: ${division}`]);
    currentRowIdx = worksheet.rowCount;
    let endColumnIdx = worksheet.columnCount;
    worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, endColumnIdx);
    divisionRow.getCell(1).alignment = {horizontal: 'left'};
    const periodRow = worksheet.addRow([`Period: ${period}`]);
    currentRowIdx = worksheet.rowCount;
    endColumnIdx = worksheet.columnCount;
    worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, endColumnIdx);
    periodRow.getCell(1).alignment = {horizontal: 'left'};
    worksheet.addRow([]);
    const header = [
      'User ID',
      'SapCode',
      'Designation Id',
      'Designation',
      'Staff Name',
      'Expense Month',
      'Expense Year',
      'Division Id',
      'Division',
      'hqId',
      'HQ',
      'Status',
    ];
    worksheet.addRow(header);
    statusReportData?.row?.forEach((rowData: any) => {
      const rowValues = getRowValues(tableRowKeys, rowData);
      if (rowData.section === 'G. Total' || rowData.section === 'Total') {
        currentRowIdx = worksheet.rowCount;
        rowValues.splice(0, 1, null);
        worksheet.addRow(rowValues);
        worksheet.getRow(currentRowIdx + 1).font = {bold: true};
      } else {
        worksheet.addRow(rowValues);
      }
    });

    worksheet.getRow(4).font = {bold: true};
    worksheet.getRow(4).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'C0C0C0'},
    };

    worksheet.addRow([]);
    worksheet.addRow([]);
    currentRowIdx = worksheet.rowCount;
    worksheet.getRow(currentRowIdx).font = {bold: true};
    worksheet.getRow(currentRowIdx).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: 'C0C0C0'},
    };

    fitToColumnExcelJs(
      worksheet,
      [...(statusReportData?.row ?? '')],
      tableRowKeys,
    );

    workbook.xlsx
      .writeBuffer()
      .then(buffer => {
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const fileName = `ExpenseStatusReport.xlsx`;
        saveAs(blob, fileName, {autoBom: false});
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleOnClickGo = () => {
    dispatch(
      fetchExpenseStatusReportCreator({
        divId: filterData?.divisionId,
        period: monthYearData
          .filter(monthYear =>
            filterData.monthYearData.includes(monthYear.month),
          )
          .map((monthYear: any) => ({
            month: monthYear.month,
            year: monthYear.year,
          })),
        status: expenseStatus,
        empCodes: selectedStaffData
          .map((element: string) => ({
            sapCode: element,
          }))
          .filter((ele: any) => Boolean(ele)),
        InActive: !isActive,
      }),
    );
    setReport(true);
    setOpen(true);
  };

  const validation = () => {
    if (
      filterData?.divisionId?.length !== 0 &&
      filterData?.monthYearData?.length !== 0 &&
      filterData?.monthYearData !== undefined &&
      expenseStatus.length !== 0
    ) {
      setValidated(false);
    } else {
      setValidated(true);
    }
  };

  useEffect(() => {
    validation();
  }, [
    filterData?.divisionId,
    filterData?.monthYearData,
    selectedStaffData,
    expenseStatus,
  ]);

  useEffect(() => {
    dispatch(fetchDivisionDataCreator());
    return () => {
      dispatch(expenseReportsActions.resetFiltersTA());
      dispatch(expenseReportsActions.setStatusReportData(null));
      dispatch(expenseReportsActions?.setSelectedStaffData([]));
      setSelectedStaff([]);
    };
  }, []);
  useEffect(() => {
    dispatch(expenseReportsActions.setStatusReportData(null));
    dispatch(expenseReportsActions?.setSelectedStaffData([]));
    dispatch(approveExpenseStateActions?.setStaffData([]));
    setSelectedStaff([]);
  }, [isActive]);

  utilTA.staffEditHandler = staffEditHandler;
  utilTA.changeDivisionId = changeDivisionId;
  utilTA.changeMonthYears = changeMonthYears;
  utilTA.onStaffChange = onStaffChange;
  utilTA.handleClickGo = handleOnClickGo;

  return (
    <>
      <div style={divisionContainer}>
        <Grid container spacing={0.5} sx={{m: 0.5, width: '87%'}}>
          <Grid item xs={3.8}>
            <Box>
              <Box sx={{margin: 1}}>
                <Typography className={classes.label}>
                  {strings.ModuleSpecificUtilitie.expenseReportPage.Division}
                </Typography>
              </Box>
              <FormControl
                data-testid={'division-select'}
                required
                fullWidth
                size="small">
                <InputLabel id="division-dropdown">
                  {strings.ModuleSpecificUtilitie.expenseReportPage.Division}
                </InputLabel>
                <Select
                  data-testid="division-select"
                  inputProps={{
                    'data-testid': 'dropdown-division',
                  }}
                  labelId="division-dropdown"
                  id="division-dropdown"
                  size="small"
                  value={filterData?.divisionId || []}
                  title={
                    divisionData
                      .filter((division: any) =>
                        filterData?.divisionId?.includes(division?.value),
                      )
                      ?.map((division: any) => division.label)
                      .join(',') || ''
                  }
                  label="Division*"
                  MenuProps={MenuProp}
                  onChange={(event: any) =>
                    changeDivisionId(event?.target?.value, 'divisionId')
                  }
                  multiple
                  renderValue={selected => (
                    <div style={style.change}>
                      {divisionData
                        .filter((division: any) =>
                          selected.includes(division.value),
                        )
                        .map((division: any) => `${division.label}`)
                        .join(',') || ''}
                    </div>
                  )}>
                  <MenuItem value={0} key={0}>
                    <CustomMenuItem
                      checked={
                        filterData?.divisionId?.length === divisionData.length
                      }
                      label={strings.SelectAll}
                      value={0}
                    />
                  </MenuItem>
                  {(divisionData || [])?.map((currentDivisionValue: any) => {
                    return (
                      <MenuItem
                        value={currentDivisionValue?.value}
                        key={currentDivisionValue?.value}
                        disabled={
                          filterData?.divisionId
                            ? filterData?.divisionId.length === 10 &&
                              !filterData?.divisionId.includes(
                                currentDivisionValue?.value,
                              )
                            : false
                        }>
                        <CustomMenuItem
                          checked={filterData?.divisionId?.some(
                            (val: any) => val == currentDivisionValue?.value,
                          )}
                          label={currentDivisionValue?.label}
                          value={currentDivisionValue?.value}
                        />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={1.9}>
            <Box>
              <Box sx={{m: 1}}>
                <Typography className={classes.label}>
                  {strings.ModuleSpecificUtilitie.expenseReportPage.Date}
                </Typography>
              </Box>
              <FormControl fullWidth required size="small">
                <InputLabel>
                  {strings.ModuleSpecificUtilitie.expenseReportPage.mmyy}
                </InputLabel>
                <Select
                  id="month-dropdown"
                  labelId="month-dropdown"
                  size="small"
                  inputProps={{
                    'data-testid': 'dropdown-month',
                  }}
                  label="mm/yy*"
                  onChange={(event: any) => {
                    changeMonthYears(event?.target?.value, 'monthYearData');
                  }}
                  value={filterData?.monthYearData || []}
                  title={
                    monthYearData
                      .filter((monthValue: any) =>
                        filterData?.monthYearData?.includes(monthValue?.month),
                      )
                      ?.map((monthvalue: any) =>
                        monthvalue !== 0
                          ? `${monthvalue.monthDesc}-${monthvalue?.year}`
                          : `${monthvalue?.monthDesc}`,
                      )
                      .join(',') || ''
                  }
                  multiple
                  renderValue={selected => (
                    <div style={style.change}>
                      {monthYearData
                        .filter(monthYear => selected.includes(monthYear.month))
                        .map((monthYear: any) => {
                          return (
                            selected?.includes(monthYear?.month) &&
                            `${monthYear.monthDesc}-${monthYear.year}
                        `
                          );
                        })
                        .filter((element: any) => Boolean(element))
                        .join(',')}
                    </div>
                  )}>
                  <MenuItem value={0} key={0}>
                    <CustomMenuItem
                      checked={
                        filterData?.monthYearData?.length ===
                        monthYearData.length
                      }
                      label="Select All"
                      value={0}
                    />
                  </MenuItem>
                  {(monthYearData || [])?.map((monthValue: any) => (
                    <MenuItem key={monthValue?.month} value={monthValue.month}>
                      <CustomMenuItem
                        value={monthValue.month}
                        checked={filterData?.monthYearData?.some(
                          (o: number) => o === monthValue?.month,
                        )}
                        label={`${monthValue?.monthDesc}-${monthValue?.year}`}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={1.9}>
            <Box>
              <Box sx={{m: 1}}>
                <Typography className={classes.label}>
                  {strings.ModuleSpecificUtilitie.expenseReportPage.status}
                </Typography>
              </Box>
              <FormControl fullWidth required size="small">
                <InputLabel>
                  {strings.ModuleSpecificUtilitie.expenseReportPage.status}
                </InputLabel>
                <Select
                  label="Status*"
                  id="month-dropdown"
                  labelId="month-dropdown"
                  size="small"
                  inputProps={{
                    'data-testid': 'dropdown-status',
                  }}
                  multiple
                  value={expenseStatus || []}
                  onChange={handleChange}
                  input={<OutlinedInput label="Name" />}
                  MenuProps={MenuProps}
                  renderValue={selected => (
                    <div style={style.change}>
                      {' '}
                      {names
                        .filter(name => selected.includes(name))
                        .map(value => value)}
                    </div>
                  )}>
                  <li style={selectAllContainer}>
                    <div className={styles.checkbox} >
                      <input
                        style={checkmark}
                        type="checkbox"
                        id="selectAll"
                        value={1}
                        checked={expenseStatus.length === names.length}
                        onChange={handleSelectAll}
                      />
                      <span className={styles.checkmark}></span>
                      {strings.SelectAll}
                    </div>
                  </li>
                  {names.map(name => (
                    <MenuItem key={name} value={name}>
                      <CustomMenuItem
                        value={name}
                        checked={expenseStatus.includes(name)}
                        label={`${name}`}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={3.8}>
            <Box>
              <Box sx={{margin: 1}}>
                <Typography className={classes.label}>
                  {strings.ModuleSpecificUtilitie.expenseReportPage.Staff}
                </Typography>
              </Box>
              <SelectStaff
                filteredData={filterData}
                onStaffChange={onStaffChange}
                selectedStaff={selectedStaff}
                selectedStaffData={selectedStaffData}
                type="TA">
                <SearchComponent staffEditHandler={staffEditHandler} />
                {isLoading && (
                  <Box className={classes.loading}>{strings.loading}</Box>
                )}
                {!isLoading && !staffData.length && (
                  <Box className={classes.loading}>{strings.noOptions}</Box>
                )}
                {selectedStaff.map((staffVal: any) => (
                  <MenuItem
                    key={staffVal?.staffPositionId}
                    value={staffVal?.employeeCode}>
                    <Checkbox
                      checked={selectedStaffData?.some(
                        (o: any) => o == staffVal?.employeeCode,
                      )}
                    />
                    {`${staffVal?.fullName}-${staffVal?.employeeCode}`}
                  </MenuItem>
                ))}

                {staffData
                  ?.filter(
                    (staff: any) =>
                      !selectedStaffData.includes(staff.employeeCode),
                  )
                  .map((staffVal: any) => (
                    <MenuItem
                      key={staffVal?.staffPositionId}
                      value={staffVal?.employeeCode}>
                      <Checkbox
                        checked={selectedStaffData?.some(
                          (o: any) => o == staffVal?.employeeCode,
                        )}
                      />
                      {`${staffVal?.fullName}-${staffVal?.employeeCode}`}
                    </MenuItem>
                  ))}
              </SelectStaff>
            </Box>
          </Grid>
          <Grid item xs={0.5} marginTop={4.2}>
            <DebouncedButton
              data-testid="button-go"
              variant="contained"
              size="large"
              onClick={handleOnClickGo}
              disabled={validated}>
              {strings.Go}
            </DebouncedButton>
          </Grid>
        </Grid>
      </div>
      {open && statusReportData?.row?.length > 0 && (
        <div style={buttonContainer}>
          <Button
            data-testid="download-pdf"
            variant="contained"
            sx={{marginLeft: 2}}
            onClick={generatePDF}
            style={{width: 150, margin: 5}}>
            {strings.ModuleSpecificUtilitie.DownloadPdf}
          </Button>
          <Button
            data-testid="download-excel"
            variant="contained"
            onClick={downloadExcel}
            style={{width: 150, margin: 5}}>
            {strings.ModuleSpecificUtilitie.ExportToExcel}
          </Button>
        </div>
      )}
    </>
  );
};

export default ExpenseStatusReportHeader;
